// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import useAuth from 'hooks/useAuth';
import { buildMenuItems } from 'menu-items';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //
// Skupinový "sidebar_label" banner (2026-08-23, core_groups.sidebar_label,
// migrace 034) - 2026-08-29 na výslovné přání uživatele přesunut z
// samostatného řádku NAD "ADMINISTRACE" přímo DO titulku menu skupiny
// (nahrazuje "ADMINISTRACE" pro členy skupiny, která banner má nastavený,
// viz menu-items/admin.jsx's buildAdminMenu()) - tady se už nic zvlášť
// nerenderuje, jen se skrz `user` propaguje dál.

export default function Navigation() {
  const { user } = useAuth();
  const menuItem = buildMenuItems(user);

  // "Dashboard" odkaz v sidebaru pryč (2026-08-22, na přání uživatele) -
  // logo DO-RA nahoře už je funkční odkaz na dashboard (components/logo,
  // APP_DEFAULT_PATH), takže samostatná položka byla duplicitní. Skupina
  // 'group-dashboard' (menu-items/dashboard.jsx) zůstává v datech
  // nedotčená - PageTitle.jsx/Breadcrumbs.jsx ji pořád potřebují pro
  // dohledání názvu/ikony stránky, jen se v sidebaru nerenderuje.
  const navGroups = menuItem.items
    .filter((item) => item.id !== 'group-dashboard')
    .map((item) => {
      switch (item.type) {
        case 'group':
          return <NavGroup key={item.id} item={item} />;
        default:
          return (
            <Typography key={item.id} variant="h6" sx={{ color: 'error.main', textAlign: 'center' }}>
              Fix - Navigation Group
            </Typography>
          );
      }
    });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
